import withStyles from '@mui/styles/withStyles';
import {color, radius, shadow} from "common/tokens";
import React from "react";
import FullScreenMessengerContainer from "containers/FullScreenMessengerContainer";


const styles = () => ({
  // One bordered panel holding both columns, filling whatever height the page
  // gives it rather than a fixed 530px.
  wrapper: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    display: 'flex',
    background: color.SURFACE,
    border: `1px solid ${color.CARD_BORDER}`,
    borderRadius: radius.CARD,
    boxShadow: shadow.PANEL,
    overflow: 'hidden',
  },
});


const ChatWindow = ({classes,}) => {

  return (
    <div className={classes.wrapper}>
      <FullScreenMessengerContainer/>
    </div>
  );
};

export default withStyles(styles)(ChatWindow);


